export const DEFAULT_OG_IMAGE =
  'https://www.nerdwallet.com/assets/img/nw-logos/NW-default_og-image.jpg';
export const DEFAULT_OG_IMAGE_HEIGHT = 78;
export const DEFAULT_OG_IMAGE_WIDTH = 150;
